$(document).ready(function () {
	//Hide element when smaller than 1025
	if ($(window).width() < 1025) {
		$(".header-bottom").fadeIn(function () {
			$(".header-bottom").css({
				display: "flex"
			});
		});
		toggleSearch();
	}

	//Library Base function

	setBackground();
	tabActive();
	swiperInit();
	toggleMobileMenu();
	stickyNav();
	sideNavigation();
	//Declare NEW function Javascript
	backToTop();
	animationInit();
	appendHtml();
	activeMap();
	scrollNext();

});

window.onscroll = function () {
	fixHeader();
};;

function scrollNext() {
	$(".arrow-down-next").click(function () {
		var $nextElement = $(this).parents('.Module').next();
		// Check if next element actually exists
		if ($nextElement.length) {
			// If yes, update:
			// 1. $currentElement
			// 2. Scroll position
			$('html, body').stop(true).animate({
				scrollTop: $nextElement.offset().top
			}, 600);
		}
		return false;
	});

}

function activeMap() {

	$('.contact-display .item').on('click', function () {
		$('.contact-display .item').removeClass('active');
		$(this).addClass('active');
		let data = $(this).attr('data-map');
		$('.contact-display .map-wrapper iframe').attr('src', data)
	})

}



function animationInit() {
	var txt = $(".btn-split").text();
	$(".btn-split").attr("name", txt);
}

function appendHtml() {
	//Append Product Detail Form
	if ($("body").hasClass("product-detail-page")) {
		if ($(".subscrible-form").length) {
			$('.subscrible-form').insertBefore('.other-product')
		}
	}
	if ($("body").hasClass("apartment-detail-page")) {
		if ($(".subscrible-form").length) {
			$('.subscrible-form').appendTo('.aparment-detail-8')
		}
	}
	if ($("body").hasClass("apartment-detail-page")) {
		if ($(".other-project-detail").length) {
			$('.other-project-detail').appendTo('.aparment-detail-9')
		}
	}

}

function fixHeader() {
	if ($(window).width() > 1025) {

		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			$("header").addClass("minimize");
		} else {
			$("header").removeClass("minimize");
		};
	}
}



function backToTop() {
	let btn = $(".back-to-top");
	btn.on("click", function (e) {
		e.preventDefault();
		$("html, body").animate({
				scrollTop: 0
			},
			"300"
		);
	});
	$(".primary-banner .wheel").click(function () {
		var $nextElement = $(this).parents('.Module').next();
		// Check if next element actually exists
		if ($nextElement.length) {
			// If yes, update:
			// 1. $currentElement
			// 2. Scroll position
			$('html, body').stop(true).animate({
				scrollTop: $nextElement.offset().top - $("header").outerHeight()
			}, 600);
		}
		return false;
	});
}



function swiperInit() {
	var homerSwiper = new Swiper(".primary-banner .swiper-container", {
		// Optional parameters
		slidesPerView: 1,
		speed: 1205,
		// autoplay: {
		// 	delay: 2500
		// },
		lazy: {
			loadPrevNext: true,
		},
		pagination: {
			el: '.primary-banner  .swiper-pagination',
			type: 'bullets',
			clickable: true
		},
	});
	var homeProduct = new Swiper(".swiper-home-product  .swiper-container", {
		// Optional parameters
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 2500
		},
		navigation: {
			nextEl: ".swiper-home-product .nav-arrow-next",
			prevEl: ".swiper-home-product .nav-arrow-prev"
		},
		lazy: {
			loadPrevNext: true,
		},
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 2,

				spaceBetween: 10,
			},
			420: {
				slidesPerView: 3,

				spaceBetween: 10,
			},
			576: {
				slidesPerView: 4,

			},
			1025: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
			1440: {
				slidesPerView: 4,
				slidesPerColumn: 2,
				spaceBetween: 10,
			}
		},

	});


	var topBanner = new Swiper(".top-banner .swiper-container", {
		// Optional parameters
		speed: 1205,
		lazy: {
			loadPrevNext: true,
		},
		slidesPerView: 1,
		autoplay: {
			delay: 2500
		}
	});

	var swiperThumb = new Swiper(".swiper-project-thumb  .swiper-container", {
		spaceBetween: 30,
		freeMode: false,
		direction: "horizontal",
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 2,

				spaceBetween: 10,
			},
			400: {
				slidesPerView: 3,

				spaceBetween: 10,
			},
			576: {
				slidesPerView: 4,

			},
			1025: {
				slidesPerView: 3,
				spaceBetween: 30,
			},

		},
		watchSlidesVisibility: true,
		watchSlidesProgress: true,

	});

	var swiperMain = new Swiper(".swiper-project-top .swiper-container", {
		slidesPerView: 1,
		centeredSlides: true,
		effect: "fade",
		lazy: {
			loadPrevNext: true,
		},

		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 2500
		},
		speed: 750,
		loop: false,
		navigation: {
			nextEl: ".project-detail .nav-arrow-next",
			prevEl: ".project-detail .nav-arrow-prev"
		},
		thumbs: {
			swiper: swiperThumb
		}
	});
	try {
		productMain.slideTo(1, false, false);

	} catch (error) {

	}

	var historyThumb = new Swiper(".swiper-history-thumb  .swiper-container", {
		spaceBetween: 0,
		freeMode: false,
		breakpointsInverse: true,
		breakpoints: {
			300: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			450: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,

			}

		},
		watchSlidesVisibility: true,
		watchSlidesProgress: true,

	});

	var historyMain = new Swiper(".swiper-history-top .swiper-container", {
		slidesPerView: 1,

		spaceBetween: 10,
		lazy: {
			loadPrevNext: true,
		},
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 2500
		},
		speed: 750,
		loop: false,
		navigation: {
			nextEl: ".swiper-history-thumb .nav-arrow-next",
			prevEl: ".swiper-history-thumb .nav-arrow-prev"
		},
		thumbs: {
			swiper: historyThumb
		}
	});


	// Product

	var productThumb = new Swiper(".swiper-product-thumb  .swiper-container", {
		spaceBetween: 0,
		freeMode: false,
		breakpointsInverse: true,
		breakpoints: {
			300: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			3: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024.1: {
				direction: 'vertical',
				slidesPerView: 4,
				spaceBetween: 30,
			}
		},
		watchSlidesVisibility: true,
		watchSlidesProgress: true,

	});

	var productMain = new Swiper(".swiper-product-main .swiper-container", {
		slidesPerView: 1,
		lazy: {
			loadPrevNext: true,
		},
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 2500
		},
		speed: 750,
		loop: false,
		navigation: {
			nextEl: ".swiper-product-thumb .nav-arrow-next",
			prevEl: ".swiper-product-thumb .nav-arrow-prev"
		},
		thumbs: {
			swiper: productThumb
		}
	});







	$(".single-swiper .swiper-container").each(function (index, element) {
		var $this = $(this);
		$this.addClass("single-instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-instance-single-" + index);

		var swiper = new Swiper(".single-instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 2500
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			slidesPerView: 1,
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			},
			pagination: {
				el: '.pagination-instance-single-' + index,
				type: 'bullets',
				clickable: true
			},
		});
	});


	$(".trinity-swiper .swiper-container").each(function (index, element) {
		var $this = $(this);
		$this.addClass("tri-instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-instance-tri-" + index);
		var swiper = new Swiper(".tri-instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 2500
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
					spaceBetween: 10,
				},
				420: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			},
			pagination: {
				el: '.pagination-instance-tri-' + index,
				type: 'bullets',
				clickable: true
			},

		});
	});

	$(".four-swiper .swiper-container").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-instance-four-" + index);
		var swiper = new Swiper(".instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			spaceBetween: 30,
			autoplay: {
				delay: 2500
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
				410: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			},
			pagination: {
				el: '.pagination-instance-four-' + index,
				type: 'bullets',
				clickable: true
			},

		});
	});
	$(".quad-swiper .swiper-container").each(function (index, element) {
		var $this = $(this);
		$this.addClass("quad-instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);
		$this.parent().find(".swiper-pagination").addClass("pagination-instance-quad-" + index);
		var swiper = new Swiper(".quad-instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 2500
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
				410: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				769: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
				1280: {
					slidesPerView: 5,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			},
			pagination: {
				el: '.pagination-instance-quad-' + index,
				type: 'bullets',
				clickable: true
			},

		});
	});
	var partnerSwiper = new Swiper(".partner-swiper .swiper-container", {
		speed: 1205,
		lazy: {
			loadPrevNext: true,
		},
		autoplay: {
			delay: 2500
		},
		speed: 750,
		observer: true,
		spaceBetween: 30,
		observeParents: true,
		breakpointsInverse: true,
		breakpoints: {
			200: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			410: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			769: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4,
			},
			1280: {
				slidesPerView: 6,
			},
		},
		navigation: {
			nextEl: ".partner-swiper .nav-arrow-next",
			prevEl: ".partner-swiper .nav-arrow-prev"
		}

	});

}


function mappingSearch() {
	return new MappingListener({
		selector: ".search-wrapper",
		mobileWrapper: ".mobile-wrapper",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-bottom",
		desktopMethod: "appendTo",
		breakpoint: 1025
	}).watch();
}


function sideNavigation() {

	$('.side-navigation-nav .title em').on('click', function () {
		if ($(this).parents('li').hasClass('active')) {
			$('.side-navigation-nav .dropdown').slideUp();
			$('.side-nav li').removeClass('active');
		} else {
			$('.side-navigation-nav .dropdown').slideUp();
			$('.side-nav li').removeClass('active');
			$(this).parent().next().slideDown();
			$(this).parents('li').addClass('active')
		}
	})
}


//Toggle mobile menu

function toggleMobileMenu() {
	var $hamburger = $(".hamburger");
	$(".main-menu-toggle").on("click", function () {
		$('.navbar-primary-menu ').toggleClass('open-menu')
		$('.language-wrapper ').toggleClass('open-menu')
		$('body').toggleClass('open-menu')
		$hamburger.toggleClass("is-active");
	});
	//mobile filter
	$('.drop-down .title em').on('click', function () {
		if ($(this).parents('.drop-down').hasClass('open-sub')) {
			$('.drop-down .nav-sub').slideUp();
			$('.drop-down').removeClass('open-sub');
		} else {
			$('.drop-down .nav-sub').slideUp();
			$('.drop-down').removeClass('open-sub');
			$(this).parent().next().slideDown();
			$(this).parents('.drop-down').addClass('open-sub')
		}
	})

	$('.filter-toggle').on('click', function () {
		console.log(123123)
		$('.filter-wrapper').slideToggle();
	})

}
$('body').on('click', '.filter-item .ajaxlink', function () {
	if ($(this).hasClass('active')) {
		$(this).removeClass('active')
		console.log('active filter')
	} else {
		$(this).addClass('active')
		console.log('not active')
	}
});

function stickyNav() {
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: $("header").outerHeight() - 40,
		});
	}

	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".about-section-wrapper .about-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					$("header").outerHeight() - 1 <= scrollDistance
				) {
					$(".sticky-nav li.active").removeClass("active");
					$(".sticky-nav li").eq(i).addClass("active");
				}
			});
		})
		.scroll();
	$(".sticky-nav a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate({
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});
}

function toggleSearch() {
	let button = $(".search-toggle");
	let search = $(".searchbox");
	button.on("click", function () {
		if (search.hasClass('active')) {
			search.removeClass('active')
		} else {
			search.addClass('active')
		}
	});
}

//Tab active

function tabActive() {
	$(".tab-navigation li a").on("click", function () {
		$(this)
			.parents(".tab-navigation")
			.find("li")
			.removeClass("active");
		$(this)
			.parents("li")
			.addClass("active");

		var display = $(this).attr("data-type");
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}
// Side 
function setBackground() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center",
		});
	});
	$("[setBackgroundRepeat]").each(function () {
		var background = $(this).attr("setBackgroundRepeat");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "repeat",
		});
	});
}



$(document).ready(function () {
	jQuery(function ($) {
		"use strict";
		var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"
		var $counters = $(".counter");
		/* Start counting, do this on DOM ready or with Waypoints. */
		$counters.each(function (ignore, counter) {
			var waypoint = new Waypoint({
				element: $(this),
				handler: function () {
					counterUp(counter, {
						duration: 5000,
						delay: 16
					});
					this.destroy();
				},
				offset: "bottom-in-view"
			});
		});
	});
});
